import { render } from "./Deals.vue?vue&type=template&id=8c9c6cca&scoped=true&ts=true"
import script from "./Deals.vue?vue&type=script&lang=ts"
export * from "./Deals.vue?vue&type=script&lang=ts"

import "./Deals.vue?vue&type=style&index=0&id=8c9c6cca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c9c6cca"]])

export default __exports__